import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana45Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_23556)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M350.909 366.64L370.253 381.521L341.98 426.163L291.387 394.914L328.588 369.617C339.004 363.664 345.948 364.656 350.909 366.64Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("19"))}
        d="M246.749 423.186L291.387 394.913L316.684 411.282L285.435 461.875L246.749 439.555C239.606 433.602 243.772 426.162 246.749 423.186Z"
        fill={getFillByLot(19, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("18"))}
        d="M328.591 484.193L285.438 461.872L316.687 411.278L356.864 436.575L328.591 484.193Z"
        fill={getFillByLot(18, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M416.377 414.261L370.248 381.523L341.975 426.165L389.592 455.926L416.377 414.261Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M465.488 448.484L416.383 414.259L389.598 455.924L441.679 487.173L465.488 448.484Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("17"))}
        d="M374.715 508.008L328.586 484.2L356.859 436.582L402.988 463.367L374.715 508.008Z"
        fill={getFillByLot(17, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("16"))}
        d="M422.336 533.302L374.719 508.005L402.992 463.363L447.633 491.636L422.336 533.302Z"
        fill={getFillByLot(16, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("15"))}
        d="M474.41 561.578L422.328 533.305L447.625 491.64L499.707 521.401L474.41 561.578Z"
        fill={getFillByLot(15, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M520.542 484.198L465.485 448.484L441.676 487.174L499.71 521.399L520.542 484.198Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M578.579 521.398L520.546 484.197L499.713 521.398L557.747 557.112L578.579 521.398Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("14"))}
        d="M530.964 591.333L474.418 561.572L499.715 521.395L553.285 554.132L530.964 591.333Z"
        fill={getFillByLot(14, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("13"))}
        d="M572.622 610.679L530.957 591.334L553.278 554.133L620.24 591.334L583.039 622.583L572.622 610.679Z"
        fill={getFillByLot(13, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M638.097 557.108L578.575 521.395L559.23 557.108L618.752 591.333L638.097 557.108Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("12"))}
        d="M606.842 661.277L583.033 622.588L620.234 591.339L649.995 610.684L658.924 622.588L606.842 661.277Z"
        fill={getFillByLot(12, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        d="M694.645 588.363L638.099 557.114L620.242 591.339L650.003 610.684L658.931 622.588L669.348 634.493L694.645 588.363Z"
        fill={getFillByLot(7, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        d="M733.332 610.682L694.643 588.361L669.346 634.491L699.107 671.692L733.332 610.682Z"
        fill={getFillByLot(8, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("11"))}
        d="M627.686 696.983L606.854 661.269L658.935 622.58L684.232 653.829L627.686 696.983Z"
        fill={getFillByLot(11, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        d="M639.59 717.82L627.686 696.987L684.231 653.834L699.112 671.691L709.528 688.059L654.47 723.772C646.137 724.963 641.078 720.3 639.59 717.82Z"
        fill={getFillByLot(10, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        d="M773.512 649.367L709.526 688.056L699.109 671.688L733.334 610.678L776.488 632.998C778.869 640.141 775.496 646.887 773.512 649.367Z"
        fill={getFillByLot(9, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_23556"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_23556"
            transform="matrix(0.00204111 0 0 0.00270596 -2.14394 -1.74815)"
          />
        </pattern>
        <image
          id="image0_1466_23556"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
